var _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 200,
    viewBox: "0 0 260 200",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2489",
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      vectorEffect: "none",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 7.80472,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m -48.703535,-23.53191 c 10.314473,0.144026 18.727018,-7.595635 18.863246,-17.351602 l 2.407631,-172.422638 c 0.136228,-9.75597 -8.056961,-17.72555 -18.371434,-17.86958 l -214.559158,-2.996 c -10.31448,-0.14403 -18.72895,7.59365 -18.86518,17.34962 l -2.40763,172.422638 c -0.13623,9.755967 8.05889,17.727529 18.37337,17.871556 z m -86.081555,-15.883123 c -5.86741,-0.259876 -11.35437,-3.276319 -14.4034,-8.557406 l -61.88634,-107.192871 c -4.87846,-8.44975 -1.61521,-19.40459 7.31827,-24.56232 l 66.06632,-38.14184 c 8.93347,-5.15775 20.05272,-2.50732 24.93118,5.94242 l 61.886341,107.19288 c 4.878458,8.449733 1.615199,19.404581 -7.318267,24.56232 l -66.064374,38.141861 c -3.35005,1.934153 -7.00927,2.770882 -10.52973,2.614956 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "none"
    },
    transform: "translate(-25,-25)"
  }, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 327,
    height: 248,
    preserveAspectRatio: "none",
    id: "image157",
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    transform: "translate(-25,-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "none",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeWidth: 20,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      stopColor: "#000000"
    },
    id: "rect373-3-6",
    width: 113.52525,
    height: 158.99957,
    x: -263.12363,
    y: -218.62152,
    ry: 17.611782,
    rx: 18.620014,
    transform: "rotate(179.2,5.9930186,1.0418886)",
    clipPath: "url(#clipPath2487)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-25,-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeWidth: 20,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      stopColor: "#000000"
    },
    id: "rect373-3",
    width: 113.52525,
    height: 158.99957,
    x: -95.910332,
    y: -247.42365,
    ry: 17.611782,
    rx: 18.620014,
    transform: "rotate(149.2)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.5c4311304b6723db1342b2925b8c3d01.svg";
export { ForwardRef as ReactComponent };